import { clampTweaks, type WeaponTweaks } from '@cuboom/shared';

/**
 * The weapon-tuning screen's home: stock knobs live in localStorage until
 * the player turns them. The loaded value is baked into the next match's
 * config, so the sim (and the server, for online play) only ever sees the
 * sanitized copy.
 */
const LS_KEY = 'cuboom.weaponTweaks';

export function loadWeaponTweaks(): WeaponTweaks | undefined {
  try {
    const raw = localStorage.getItem(LS_KEY);
    if (!raw) return undefined;
    return clampTweaks(JSON.parse(raw));
  } catch {
    /* private mode / corrupt JSON — stock values are fine */
    return undefined;
  }
}

export function saveWeaponTweaks(t: WeaponTweaks | undefined): void {
  try {
    if (!t || !Object.keys(t).length) localStorage.removeItem(LS_KEY);
    else localStorage.setItem(LS_KEY, JSON.stringify(t));
  } catch {
    /* ignore — tuning stays session-local if storage is blocked */
  }
}
